import {
  ExIconButton, IconButtonFlavor, IconButtonSize, IconButtonType,
} from '@boomi/exosphere';
import { useTranslation } from 'react-i18next';
import '../PreviewSection.scss';
import { generateUniqueKey } from '@services/agent-foundation/agent-foundation-api-service';

function GuardrailSection({ template, handleStepClick, showEdit }: any) {
  const [t] = useTranslation('common');
  return (
    <div className="review-agent-container">
      {showEdit && (
        <div className="preview-button-container">
          <div className="agent-title">{t('review_panel_guardrail_title')}</div>
          <ExIconButton
            icon="pencil"
            data-testid="review-edit-guardrails-button"
            type={IconButtonType.TERTIARY}
            flavor={IconButtonFlavor.BASE}
            size={IconButtonSize.SMALL}
            tooltipText="Edit"
            onClick={(e: any) => {
              handleStepClick(e, 'Guardrails');
            }}
          />
        </div>
      )}
      <div className="review-agent-section task-section">
        <div className="info-row">
          <div className="info-key">{t('blocked_message')}</div>
          <div className="info-value">
            {template?.blockedMessage?.length
              ? template?.blockedMessage : '\u2013'}
          </div>
        </div>
        <div className="info-row">
          <div className="info-key">{t('denied_topics')}</div>
          <div className="info-value">

            {template?.deniedTopicsValues?.length > 0
                  && (
                  <ul>
                    {template?.deniedTopicsValues?.map((deniedTopic: any) => (
                      <li key={deniedTopic.id}>
                        {deniedTopic.name}
                        :&nbsp;
                        <span className="denied-topic-description">{deniedTopic.description}</span>
                      </li>
                    ))}
                  </ul>
                  )}
            {!template?.deniedTopicsValues?.length
              && (
              <span>{'\u2013'}</span>
              )}
          </div>
        </div>
        <div className="info-row">
          <div className="info-key">{t('word_filters')}</div>
          <div className="info-value">

            {template?.customWords?.length > 0
                  && (
                  <ul>

                    {template?.customWords?.map((word: any, index: number) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <li key={generateUniqueKey(index)}>{word}</li>
                    ))}
                  </ul>
                  )}
            {!template?.customWords?.length
                && (
                <span>{'\u2013'}</span>
                )}

          </div>
        </div>
        <div className="info-row">
          <div className="info-key">{t('regex_patterns')}</div>
          <div className="info-value">

            {template?.customRegex?.length > 0
                  && (
                  <ul>
                    {template?.customRegex?.map((regex: any) => (
                      <li key={regex.id}>{regex.value}</li>
                    ))}
                  </ul>
                  )}
            {!template?.customRegex?.length
                && (
                <span>{'\u2013'}</span>
                )}
          </div>
        </div>
      </div>

    </div>
  );
}

export default GuardrailSection;
